export default "__VITE_ASSET__9b4a1ed2__"